import { IconDocNewspaper, IconTelegramIcon, IconVerticalMenu, Menu, UserBarItem } from '@direct-frontend/components';
import { ECOM_TELEGRAM_URL, ECOM_URL, KIT_TELEGRAM_URL } from '#shared/lib/const';
import { checkIsYCP } from '#shared/lib/ycp';

export const DashboardMarketingLinksButton = (props: { className?: string }) => {
    const { className } = props;
    const isYCP = checkIsYCP();

    return (
        <Menu
            items={[
                {
                    key: 'telegram',
                    content: isYCP ? 'Телеграм-канал' : 'Наш телеграм-канал',
                    url: isYCP ? ECOM_TELEGRAM_URL : KIT_TELEGRAM_URL,
                    target: '_blank',
                    addonLeft: <IconTelegramIcon role="main" color="gray" size="24" />,
                },
                {
                    key: 'ecom',
                    content: 'Новости Ecom',
                    url: ECOM_URL,
                    target: '_blank',
                    addonLeft: <IconDocNewspaper role="main" color="gray" size="24" />,
                },
            ]}
            data-testid="DashboardMarketingLinksButton.Menu"
            size="m"
            placement="left-start"
            trigger={
                <UserBarItem
                    className={className}
                    icon={IconVerticalMenu}
                    data-testid="DashboardMarketingLinksButton.Button"
                />
            }
        />
    );
};
